import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: "#E0EAF2",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
        greenMain: "#039de9",
      },
      dark: {
        primary: "#111A26",
        secondary: "#b0bec5",
        accent: "#8c9eff",
        error: "#b71c1c",
        greenMain: "#039de9",
      },
    },
  },
});


